<template>
    <div>
        <el-cascader ref="cascader" :style="{ width: width + 'px' }" :size="size" :disabled="disabled" v-model="pids"
            :options="options" clearable :props="{ checkStrictly: true, value: 'id', label: 'name' }"
            @change="handleChange" :placeholder="placeholder"></el-cascader>
    </div>
</template>
<script>
import { findAllAncestorIds } from '../../utils/tree'
export default {
    name: 'departmentSelect',
    model: {
        prop: 'id',
        event: 'change',
    },
    props: {
        id: {
            type: [String, Number],
        },
        width: {
            type: String,
            default: 'auto',
        },
        size: {
            type: String,
            default: 'small',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择部门',
        },
    },
    watch: {
        id: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.setPids()
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.getData()
    },
    data() {
        return {
            val: '', //选中的部门ID
            pids: [], // 选中的部门ID列表
            options: [], //树形结构数据
            list: [], //列表数据
        }
    },
    methods: {
        handleChange() {
            // 如果存在选中的父级部门ID数组，则取最后一个作为当前选中ID
            if (this.pids.length > 0) {
                const val = this.pids[this.pids.length - 1]
                this.$emit('change', val)
            } else {
                this.$emit('change', '')
            }
            // 关闭级联选择器的下拉菜单
            this.$refs.cascader.dropDownVisible = false
        },
        //设置选中的部门ID
        setPids() {
            if (this.id > 0) {
                //树形结构查找祖先节点的 ID列表（包括根节点）
                this.pids = findAllAncestorIds(this.options, this.id)
            }
        },
        //获取数据
        async getData() {
            await this.$api.department.tree().then((res) => {
                if (res.code != 200) return
                this.options = res.data
                //树形结构转换成列表结构
                this.setPids()
            })
        },
    },
}
</script>
<style></style>
